/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} State_PlannedInputs */



/**
* | output |
* | --- |
* | "Planned" |
*
* @param {State_PlannedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const state_planned = /** @type {((inputs?: State_PlannedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<State_PlannedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Planifié")
	if (locale === "es") return /** @type {LocalizedString} */ ("Planificado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Planejado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pianificato")
	return /** @type {LocalizedString} */ ("Planned")
});